import { createContext, useContext, ReactNode } from 'react';
import { useViewStateManager, TpViewStateManagerProps } from './useViewStateManager';

type ViewStateContextType = ReturnType<typeof useViewStateManager>;

const ViewStateContext = createContext<ViewStateContextType | null>(null);

export function ViewStateProvider({ children, ...hookProps }: { children: ReactNode } & TpViewStateManagerProps) {
  const manager = useViewStateManager(hookProps.assetInfo, hookProps.dataContext);
  return <ViewStateContext.Provider value={manager}>{children}</ViewStateContext.Provider>;
}

export function useViewState() {
  const context = useContext(ViewStateContext);
  if (!context) throw new Error('useViewState must be used within a ViewStateProvider');
  return context;
}
